import { NoData } from '@beehive/components';
import React from 'react';
import './index.less';
import DetailLayout from '../components/DetailLayout';

const NotPeerNode = (props: any) => {
  const { detail = {} } = props;

  return (
    <DetailLayout detail={detail}>
      <div style={{ height: '100%', position: 'relative' }}>
        <NoData text="暂未匹配到该节点"/>
      </div>
    </DetailLayout>
  );
};

export default NotPeerNode;
